import { render, staticRenderFns } from "./institutionCardDialog.vue?vue&type=template&id=375a0d44&scoped=true"
import script from "./institutionCardDialog.vue?vue&type=script&lang=ts"
export * from "./institutionCardDialog.vue?vue&type=script&lang=ts"
import style0 from "./institutionCardDialog.vue?vue&type=style&index=0&id=375a0d44&prod&scoped=true&lang=css"
import style1 from "@/components/acquisitionList/ui/itemDetails.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/components/common/profileUi/profileUi.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375a0d44",
  null
  
)

export default component.exports